import { createSlice, PayloadAction, createSelector } from '@reduxjs/toolkit'
import { InventoryItem } from './types'
import { DelyveryNotesState } from './types'
import { appStore } from '@/app/store/appStore'
import { RootState } from '@/app/store/appStore'

const initialState: DelyveryNotesState = {
  data: {
    items: [],
    vehicle_transporter: '',
    vehicle_number_plate: '',
    vehicle_type: '',
    driver_name: '',
    driver_phone: '',
  },
}

type SetFieldValuePayload<T> = {
  name: keyof T
  value: T[keyof T]
}

const returnNoteSlice = createSlice({
  name: 'returnNote',
  initialState,
  reducers: {
    setInitState(state) {
      state.data = initialState.data
    },

    setFieldValue(
      state,
      {
        payload,
      }: PayloadAction<SetFieldValuePayload<DelyveryNotesState['data']>>,
    ) {
      state.data[payload.name] = payload.value
    },
    setItemFieldValue(
      state,
      {
        payload,
      }: PayloadAction<SetFieldValuePayload<DelyveryNotesState['data']>>,
    ) {
      state.data.items = state.data.items.map(item =>
        item.id === payload.id
          ? { ...item, [payload.name]: payload.value }
          : item,
      )
    },

    setInitialItems(state, action: PayloadAction<InventoryItem[]>) {
      state.data.items = Object.values(action.payload)
        .filter(item => !!item.remaining_amount_to_return)
        .map(item => ({
          ...item,
          returned_good_condition_amount: 0,
          damaged_amount: 0,
        }))
    },
  },
  extraReducers: builder => {},
})

const selectInventoryState = (state: RootState) => state

const selectItems = (state: RootState) => state.deliveryNote.data.items

const selectFormData = (state: RootState): DelyveryNotesState['data'] =>
  state.returnNote.data

export const selectInventoryItems = createSelector(
  [selectInventoryState],
  inventoryState => Object.values(inventoryState.data.items),
)

export const selectInventoryItemsByCategory = (categoryId: number) =>
  createSelector([selectItems], items =>
    Object.values(items)
      .filter(item => item.asset_category_id === categoryId)
      .sort((a, b) => a.index - b.index),
  )

export const formDataSelector = createSelector([selectFormData], data => data)

export const {
  setFieldValue,
  setInitState,
  setInitialItems,
  setItemFieldValue,
} = returnNoteSlice.actions

export default returnNoteSlice
